function waitForElem(selector, parent = document) {
    return new Promise((resolve) => {
        if (parent) {
            const target = parent.querySelector(selector);
            if (target) {
                return resolve(target);
            }
            const observer = new MutationObserver((mutations) => {
                const target = parent.querySelector(selector);
                if (target) {
                    resolve(target);
                    observer.disconnect();
                }
            });
            observer.observe(parent, {
                childList: true,
                subtree: true,
            });
        }
    });
}

function throttle(callback, delay) {
    let lastCallTime = 0;
    let timerId;
    return function () {
        let currentTime = Date.now();
        let elapsedTime = currentTime - lastCallTime;
        if (elapsedTime < delay) {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                lastCallTime = Date.now();
                callback.apply(this, arguments);
            }, delay);
        } else {
            lastCallTime = currentTime;
            callback.apply(this, arguments);
        }
    };
}

/**
 * Makes an AJAX request to the specified URL with the given type, action, and data.
 * @param {string} url - The URL to send the request to.
 * @param {string} type - The type of request (e.g. "GET", "POST").
 * @param {string} action - The action to be performed on the server.
 * @param {object} data - Additional data to send with the request.
 * @param {function} callback - The callback function to handle the response.
 */
function makeRequest(url, type, action, data) {
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();

        if (!xhr) {
            reject("XMLHttpRequest not supported");
            return;
        }

        xhr.open(type, url, true);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

        let queryString = "action=" + action + "&";
        queryString += Object.keys(data)
            .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&");

        xhr.send(queryString);

        xhr.onreadystatechange = function () {
            try {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        resolve(xhr.responseText);
                    } else {
                        reject("There was a problem with the request. Status: " + xhr.status);
                    }
                }
            } catch (e) {
                reject("Caught Exception: " + e.description);
            }
        };
    });
}

function isOverflown(element) {
    return (
        element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth
    );
}


export {waitForElem, throttle, makeRequest, isOverflown};


